/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

const form = {
  formId: "new-location-form",
  formField: {
    name: {
      name: "name",
      label: "Nombre",
      type: "text",
      errorMsg: "El nombre es obligatorio.",
    },
    street: {
      name: "street",
      label: "Calle",
      type: "text",
      errorMsg: "La calle es obligatoria.",
    },
    exterior_number: {
      name: "exterior_number",
      label: "Número Exterior",
      type: "text",
      errorMsg: "El número exterior es obligatorio.",
    },
    interior_number: {
      name: "interior_number",
      label: "Número Interior",
      type: "text",
    },
    suburb: {
      name: "suburb",
      label: "Colonia",
      type: "text",
      errorMsg: "La colonia es obligatoria.",
    },
    postal_code: {
      name: "postal_code",
      label: "Código Postal",
      type: "text",
      errorMsg: "El código postal es obligatorio.",
    },
    city: {
      name: "city",
      label: "Ciudad",
      type: "text",
      errorMsg: "La ciudad es obligatoria.",
    },
    state: {
      name: "state",
      label: "Estado",
      type: "text",
      errorMsg: "El estado es obligatorio.",
    }
  },
};

export default form;
